/**
 * Page-level grain. The whole UI sits underneath a barely-perceptible noise
 * layer — same trick as film stock and printed paper. Without it, the
 * pastels read as "AI generated"; with it, they read as held in the hand.
 */
export function GrainOverlay() {
  return (
    <div aria-hidden style={{
      position: 'fixed', inset: 0, zIndex: 100,
      pointerEvents: 'none',
      mixBlendMode: 'multiply',
      opacity: 0.18,
      backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.85  0 0 0 0 0.78  0 0 0 0 0.80  0 0 0 0.05 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>")`,
    }} />
  );
}
